import React, { useContext, useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, ColumnProps, FormSubmitButton, MasterDetailForm, Row, Table, Widget } from '@digital/ui';

import { modificarDemanda, obterDadosAprovacaoTotvs, validarModificacaoDemanda } from '@app/api/demanda';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';

interface Props {
  setUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  update: boolean;
}
export function ModalModificarRC({ update, setUpdate }: Props) {
  const [exibirModal, setExibirModal] = useState(false);
  const { demandaData } = useContext(QuestionarioContextProvider);
  const [dataAprovacao, setdataAprovacao] = useState<any[]>([]);

  useEffect(() => {
    if (demandaData) {
      obterDadosAprovacaoTotvs(demandaData.id).then((data: any) => setdataAprovacao(data));
    }
  }, [demandaData]);

  const handleSubmit = (values: any) => {
    if (demandaData) {
      values.demandaId = demandaData.id;

      validarModificacaoDemanda(values.demandaId).then((situacao: any) => {
        if (situacao.possivelModificar) {
          modificarDemanda(values.demandaId, true).then((data: any) => {
            if (data.valid) {
              setUpdate(!update);
              setExibirModal(false);
            }
          });
        }
      });
    }
  };

  const columns: ColumnProps<any>[] = [
    {
      title: 'Aprovador',
      dataIndex: 'aprovador',
    },
    {
      title: 'Aprovador Alternativo',
      dataIndex: 'aprovadorAlternativo',
    },
    {
      title: 'Situação',
      dataIndex: 'situacao',
    },
  ];
  
  return (
    <>
      <>
        <Tooltip title="Alterar o preenchimento da RC para esta demanda">
          <Button
            id="mrn-button-modificar-demanda"
            type="primary"
            onClick={() => {
              setExibirModal(true);
            }}>
            Modificar
          </Button>
        </Tooltip>
      </>
      <Modal
        title="Modificar RC"
        visible={exibirModal}
        width="680px"
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formTemplate"
          onSubmit={handleSubmit}
          actions={[
            <Button
              id="mrn-button-modificar-demanda-modal-fechar"
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}
              key="close">
              Não
            </Button>,
            <FormSubmitButton
              id="mrn-button-modificar-demanda-modal-enviar"
              noIcon type="primary" key="save">
              Sim
            </FormSubmitButton>,
          ]}>
          <Widget style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
            <Row>
              <p>
                Ao confirmar esta ação, as aprovações que já estiverem concluídas serão eliminadas e, após a conclusão da modificação, o ciclo de aprovações será reiniciado.
                Você tem certeza?
              </p>
            </Row>
            <Row>
              <Table
                id="mrn-table-RequisicaoCompraOcDdi"
                style={{ paddingInline: '4px' }} columns={columns} dataSource={dataAprovacao} pagination={false} />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
}
